import React from 'react';

import { uiRoutes } from '@consumer-frontend/nc-api';

import { NcCheckbox } from '../NcCheckbox';
import { NcExternalLink } from '../NcExternalLink';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/consents.scss';

export type NcDelawareConsentPropsT = {
  checked?: boolean;
  defaultChecked?: boolean;
  errorMessage?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const NcDelawareConsent = ({
  checked,
  defaultChecked,
  errorMessage,
  onChange,
}: NcDelawareConsentPropsT) => {
  const label = (
    <span className="fineprint consent-text">
      By selecting this checkbox, I acknowledge that I have reviewed the{' '}
      <NcExternalLink href={uiRoutes.legacyAH.delawareConsentDisclosure}>
        Itemization of Current Charges
      </NcExternalLink>
      .
    </span>
  );

  return (
    <NcCheckbox
      id="delaware-consent"
      name="delaware-consent"
      label={label}
      checked={checked}
      defaultChecked={defaultChecked}
      errorMessage={errorMessage}
      onChange={onChange}
    />
  );
};
